import React from 'react';

const SendMilesIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-send-miles" />
    </div>
  );
};

export default SendMilesIcon;
